import { Divider } from "antd"
import { useSelector } from "react-redux"
import UMCAttrTextView from "../common/UMCAttrTextView"
import { getTranslated } from "../../utils/CommonUtils"

const OxeInfo = () => {

   const oxeAndClientInfo = useSelector(state => state.oxe.oxeAndClientInfo)
   const dict = useSelector(state => state.common.dict)

   const CLIENT_INFO = [
      [{
         id: "clientName",
         label: "PARAM_NAME"
      },
      {
         id: "clientInstallNumber",
         label: "PARAM_INSTALL_NO"
      }],
      [{
         id: "clientAddress",
         label: "PARAM_ADDRESS"
      },
      {
         id: "clientTown",
         label: "PARAM_TOWN"
      },
      {
         id: "clientCountry",
         label: "PARAM_COUNTRY"
      }]
   ]

   const OXE_INFO = [
      // Left subdomain
      [{
         id: "softwareVersion",
         label: "PARAM_SW_VERSION"
      },
      {
         id: "versionName",
         label: "PARAM_VERSION_NAME"
      },
      {
         id: "systemCountry",
         label: "PARAM_SYM_COUNTRY"
      },
      {
         id: "nodeNumber",
         label: "PARAM_NODE_NO"
      },
      {
         id: "networkNumber",
         label: "PARAM_NETWORK_NO"
      }],
      // Right subdomain
      [{
         id: "rainbowPbxId",
         label: "PARAM_RAINBOW_PBXID"
      },
      {
         id: "systemForLargeConfig",
         label: "PARAM_SYM_LR_CONF"
      },
      {
         id: "alarmRelayState",
         label: "PARAM_ALARM_RS"
      },
      {
         id: "cpuid",
         label: "PARAM_CPU_ID"
      },
      {
         id: "ccProductId",
         label: "PARAM_CCPRODID"
      },
      ]
   ]

   return <div className="oxe-info-tab">
      <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, "LABEL_CLIENT_INFO")}</Divider>
      <div className="att-flex">
         {CLIENT_INFO.map((info, index) => {
            return <div key={index}>
               {info.map(data => <UMCAttrTextView key={data.id} value={oxeAndClientInfo?.[data.id]} label={data.label} />)}
            </div>
         })}
      </div>

      <Divider orientation="left" orientationMargin="0" plain>{getTranslated(dict, "LABEL_OXE_INFO")}</Divider>
      <div className="att-flex">
         {OXE_INFO.map((info, index) => {
            return <div key={index}>
               {info.map(data => <UMCAttrTextView key={data.id} value={oxeAndClientInfo?.[data.id]} label={data.label} />)}
            </div>
         })}

      </div>
   </div>
}

export default OxeInfo